import { ActionIcon, Box, Group, Popover, Text, Tooltip } from "@mantine/core";

import SvgIconRaw from "~/components/SvgIconRaw";

import CopyButton from "../Button/CopyButton";

const ShowGMPContact = () => {
  return (
    <Box pl={8}>
      <Popover position="bottom-start" offset={8} shadow="md">
        <Popover.Target>
          <Tooltip label="Help">
            <ActionIcon
              variant="subtle"
              color="gray"
              size={16}
              aria-label="Help"
            >
              <SvgIconRaw
                name="HelpCircle"
                size={20}
                color="var(--mantine-color-text-tertiary)"
              />
            </ActionIcon>
          </Tooltip>
        </Popover.Target>
        <Popover.Dropdown miw={200}>
          <Group gap={8} wrap="nowrap">
            <Text size="xs" fw={600}>
              Got questions? Reach out to us at gls@gmpgundagai.com.au.
            </Text>
            <CopyButton
              title="Copy email address"
              text="gls@gmpgundagai.com.au"
              size={20}
              style={{ width: 20, height: 20 }}
            />
          </Group>
        </Popover.Dropdown>
      </Popover>
    </Box>
  );
};

export default ShowGMPContact;
